// English translation

const en = {
  "navbar.profile": "Profile",
  "navbar.signed_as": "Signed as",
  "navbar.signout": "Sign Out",
  "navbar.support": "Support",
  "navbar.license": "License",
  "party.party.address": "Address",
  "profile.general_information": "General Information",
  "profile.terminal": "Store / Terminal",
  "profile.terminal_name": "Name",
  "profile.change_password": "Change Password",
  "profile.new_password": "New Password",
  "profile.confirm_password": "Confirm Password",
  "profile.password_changed": "Password changed successfully",
  "profile.password_mismatch": "Passwords do not match",
  "profile.password_min_length": "Password must be at least 8 characters",
  "profile.password_error": "Error changing password",
  "button.ok": "OK",
  "button.close": "Close",
  "button.cancel": "Cancel",
  "button.yes": "Yes",
  "button.no": "No",
  "button.add": "Add",
  "button.print": "Print",
  "button.save": "Save",
  "button.mark_all_read": "Mark all as read",
  "button.accept": "Accept",
  "board.add_record": "Add",
  "board.want_to_save_data": "Do you want save the changes?",
  "board.missing_required_fields": "Missing required fields!",
  "board.record_saved": "Record saved!",
  "board.button_delete": "Delete",
  "board.button_add": "Add",
  "notification.info": "Info",
  "notification.success": "Success",
  "notification.warning": "Warning",
  "notification.error": "Error",
  "pagination.results": "Showing {firstItem} to {lastItem} of {countTotal} results",
  "table.no_data": "No data",
  "table.filter_to_see_data": "Filter to see data",
};

export default en;
